import { Tooltip } from '@mui/material'
import ElevationButton from './ElevationButton'

export default function TooltipButton({onClickFunc, title, elevation = 3, disabled = false, children}) {
  return (
      <Tooltip title={title}>
          <span>
            <ElevationButton onClick={onClickFunc} elevation={elevation} disabled={disabled}>
              {children}
            </ElevationButton>
          </span>
      </Tooltip>
  )
}
